import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

@Component({
  selector: 'app-badge-installation-state',
  templateUrl: './badge-installation-state.component.html',
  styleUrls: ['./badge-installation-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BadgeInstallationStateComponent {

  private _state: string = '';
  private _mode: 'admin' | 'connected' = 'connected';


  get state(): string {
    return this._state;
  }

  @Input({required: true})
  set state(value: string) {
    this._state = value;
  }


  get mode(): "admin" | "connected" {
    return this._mode;
  }

  @Input({required: true})
  set mode(value: "admin" | "connected") {
    this._mode = value;
  }

  public getBackgroundColor(){
    if(this._mode === 'connected'){
      if(this._state === 'PENDING' || this._state === 'AWAITING_SEND'){
        return 'text-base font-medium py-3 px-4 rounded-full bg-secondary-100';
      } else if (this._state === 'SUCCESS'){
        return 'text-base font-medium py-3 px-4 rounded-full bg-success-100';
      } else if(this._state === 'ERROR'){
        return 'text-base font-medium py-3 px-4 rounded-full bg-error-100';
      } else {
        return '';
      }
    } else {
      return 'bg-transparent'
    }
  }
}
